<template>
    <DefaultLayout>
       <!--<div v-if="loading">
            <v-icon name="ri-loader-2-fill" animation="spin" class="icon" />
        </div> --> 
        <div>
            <div class="container">
               <h1 >Agenda</h1>
                <div class="spacer" />
                <form class="search-form">
                    <v-icon name="fa-filter"></v-icon>
                    <input type="text"  placeholder="Escribe aquí para filtrar." 
                        class="input-job" />
                </form>
                <div class="spacer" />
                <div class="table-container">
                    <table class="modern-table">
                        <thead>
                            <tr>
                                <th>Fecha</th>
                                <th>Hora</th>
                                <th>Evento</th>
                                <th>Ver más</th>                             
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="elm in  quotes" :key="elm.id">
                                <td>{{ elm.date.slice(0,10) }} </td>
                                <td> {{ elm.date.slice(10,16) }}</td>
                                <td> {{ elm.title }} </td>
                                <td><RouterLink :to="{ name: 'viewAgenda', params:{id : elm?.id} }"><v-icon name="md-fileopen-round" class="ver" :fill="main.THIRD_COLOR"
                                    scale="2"></v-icon></RouterLink></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </DefaultLayout>
</template>

<script lang="ts" setup>
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import {onMounted,ref} from 'vue'
import AgendaService from '@/services/AgendaService'
import main from '@/data/main.js';

const service = new AgendaService()
const quotes:any = ref([])
const loading = ref(false)

onMounted(async()=>{
    loading.value = true
    quotes.value = await service.GetQuote()
    loading.value = false
})




/*const handleSearch = () => {
    loading.value = true
    filteredEmploys.value = employs.value.filter(item => item.name.toLowerCase().includes(search.value.toLowerCase()))
    loading.value = false
}*/
</script>

<style lang="scss" scoped>

.ofered {
    display: flex;
    justify-content: space-between;
    min-width: 130px;
}

.ofered-body {
    background-color: $third-color;
    padding: 10px;
    border-radius: 12px;
    min-height: 100px;
    max-width: 60%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    text-align: center;
    margin-right: 15px;
}

.ofered-body:hover {
    cursor: pointer;
    background-color: $secondary-color;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.title-ofered {
    color: white;
    text-decoration: none;
    border-radius: 8px;
    height: 100%;
}

.go {
    margin-top: 20px;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.separator {
    width: 10px;
}

.buttons-see {
    display: flex;
    flex-direction: column;
}

.employ-card {
    width: 100%;
    padding: 20px;
    border-radius: 10px;
    background-color: $secondary-color;
    color: white;
    margin-top: 5px;
    margin-bottom: 5px;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.title-div {
    width: 100%;
}

a {
    text-decoration: none !important;
}



.btn {
    text-decoration: none;
    margin-left: 20px;
}

.input-job {
    width: 100vw;
}

/* Estilos para la tabla */
.modern-table {
    width: 100%;
    border-collapse: collapse;

}

.modern-table th,
.modern-table td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

th {
    color: $secondary-color !important;
}

.modern-table th:first-child,
.modern-table td:first-child {
    padding-left: 20px;
}

.table-container {
    overflow-x: auto;
}

.modern-table th:last-child,
.modern-table td:last-child {
    padding-right: 20px;
}

/* Estilos para el hover */
.modern-table tbody tr:hover {
    background-color: #f5f5f5;
    transition: background-color 0.3s ease;
}

.modern-table tbody tr:hover td {
    color: #333;
}

.modern-table tbody tr:hover a {
    color: $third-color;
    transition: color 0.3s ease;
}

.btn-function {
    padding: 10px;
    background-color: $third-color;
    border: 0;
    outline: 0;
    border-radius: 5px;
    cursor: pointer;
    color: white;
    font-family: $title-font;
}

.btn-function:hover {
    background-color: $secondary-color;
}

.btn-function2 {
    padding: 10px;
    background-color: $secondary-color ;
    border: 0;
    outline: 0;
    border-radius: 5px;
    cursor: pointer;
    color: white;
    font-family: $title-font;
}

.btn-function2:hover {
    background-color: $third-color ;
}

.header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 5px;
    width: 100%;

}

@media screen and (max-width:890px) {
    .ofered {
        flex-direction: column;
        width: 100%;
        justify-content: center;
        align-items: center;
    }

    .ofered-body {
        margin-top: 20px;
        min-width: 90%;
        align-items: center;
        justify-content: center;
        padding: 15px;
    }

    .title-ofered {
        width: 100%;
    }

    .header {
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .btn-function {
        margin-top: 15px;
        min-width: 200px;
    }

    .btn-function2 {
        min-width: 200px !important;
    }

    .go {
        flex-direction: column;
    }
}
@media screen and (max-width:600px){
   tr{  display: flex;
        flex-direction: column;
    }
    td{
        text-align: left;
    }
}
</style>